import React from "react";
import { defineMessages } from "react-intl";
import * as FieldFormatters from "../common/dataList/dataListHelper";
import AdminContextMenu from "../contextMenu";
import AssignToRenderer, { AssignedToFormatter } from "./assignedToField";
import DueDateRenderer from "./dateRDDfield";
import { FormattedDate } from "react-intl";
import moment from "moment";
moment.locale("fr", { monthsShort: "janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc".split("_") });
const labels = defineMessages({
    sourceOrderId: {
        id: "task-field-label.sourceOrderId",
        defaultMessage: "Source order ID",
        description: "Source order ID column label",
    },
    clickDispatchId: {
        id: "task-field-label.clickDispatchId",
        defaultMessage: "Click dispatch ID",
        description: "Click Dispatch ID",
    },
    clickRegion: {
        id: "task-field-label.clickRegion",
        defaultMessage: "Click Region",
        description: "Click Region ID",
    },
    clickDistrict: {
        id: "task-field-label.clickDistrict",
        defaultMessage: "Click District ID",
        description: "Click district ID",
    },
    workOrderNumber: {
        id: "task-field-label.workOrderNumber",
        defaultMessage: "WO #",
        description: "WO # column label",
    },
    originalDueDate: {
        id: "task-field-label.originalDueDate",
        defaultMessage: "Due Date",
        description: "Original due date column label",
    },
    noOriginalDueDate: {
        id: "task-field-label.noOriginalDueDate",
        defaultMessage: "No original due date",
        description: "Label if original due date does not exist",
    },
    dueDate: {
        id: "task-field-label.dueDate",
        defaultMessage: "Appointment Date",
        description: "Due date column label",
    },
    SourceTicketID: {
        id: "task-field-label.sourceTicketId",
        defaultMessage: "Tech Dispatch ID",
        description: "SourceTicketId column label",
    },
    appointmentDueDate: {
        id: "task-field-label.dueDate",
        defaultMessage: "Appointment due date",
        description: "Due date column label",
    },
    phoneNumber: {
        id: "task-field-label.phoneNumber",
        defaultMessage: "",
        description: "Phone # column label",
        value: "",
    },
    circuitNumber: {
        id: "task-field-label.circuitNumber",
        defaultMessage: "Circuit #",
        description: "Circuit # column label",
    },
    workType: {
        id: "task-field-label.workType",
        defaultMessage: "Work type",
        description: "Work type column label",
    },
    networkType: {
        id: "task-field-label.networkType",
        defaultMessage: "Network type",
        description: "Network type column label",
    },
    contractor: {
        id: "task-field-label.contractor",
        defaultMessage: "Contractor",
        description: "Contractor column label",
    },
    plantType: {
        id: "task-field-label.plantType",
        defaultMessage: "Plant Type",
        description: "Plant Type column label",
    },
    activties: {
        id: "task-field-label.activities",
        defaultMessage: "Activities",
        description: "Activities column label",
    },
    Was_a_Temp_Placed: {
        id: "task-field-label.Was_a_Temp_Placed",
        defaultMessage: "Was a Temp Placed",
        description: "Was a Temp Placed column label",
    },
    status: {
        id: "task-field-label.status",
        defaultMessage: "Status",
        description: "Status column label",
    },
    reasonCode: {
        id: "task-field-label.reasonCode",
        defaultMessage: "Reason Code",
        description: "Reason  code label",
    },
    priority: {
        id: "task-field-label.priority",
        defaultMessage: "Priority",
        description: "Priority column label",
    },
    creationDate: {
        id: "task-field-label.creationDate",
        defaultMessage: "Creation date",
        description: "Creation Date column label",
    },
    resourceAssignedTo: {
        id: "task-field-label.resourceAssignedTo",
        defaultMessage: "Assigned resource",
        description: "Assigned resource column label",
    },
    scheduledDate: {
        id: "task-field-label.scheduledDate",
        defaultMessage: "Scheduled date",
        description: "Scheduled date column label",
    },
    address: {
        id: "task-field-label.address",
        defaultMessage: "Address",
        description: "Address column label",
    },
    municipality: {
        id: "task-field-label.municipality",
        defaultMessage: "Municipality",
        description: "Municipality column label",
    },
    clliCode: {
        id: "task-field-label.clliCode",
        defaultMessage: "CLLI",
        description: "CLLI column label",
    },
    manholeRoute: {
        id: "task-field-label.manholeRoute",
        defaultMessage: "Manhole route",
        description: "Manhole Route column label",
    },
    manholeId: {
        id: "task-field-label.manholeId",
        defaultMessage: "CS number",
        description: "Manhole ID (CS Number) column label",
    },
    province: {
        id: "task-field-label.province",
        defaultMessage: "Province",
        description: "Province column label",
    },
    completionDate: {
        id: "task-field-label.completionDate",
        defaultMessage: "Completed date",
        description: "Completed date column label",
    },
    completionCode: {
        id: "task-field-label.completionCode",
        defaultMessage: "Completion Code",
        description: "Complete Code column label",
    },
    notScheduled: {
        id: "task-field-label.notScheduled",
        defaultMessage: "Not Scheduled",
        description: "default message if appointment date is not scheduled",
    },
    locateNumber: {
        id: "task-field-label.locateNumber",
        defaultMessage: "Locate number",
        description: "Locate number",
    },
    requestedDate: {
        id: "task-field-label.requestedDate",
        defaultMessage: "Requested date",
        description: "Locate requested date",
    },
    expirationDate: {
        id: "task-field-label.expirationDate",
        defaultMessage: "Expiration date",
        description: "Locate expiration date",
    },
    isFlaggingRequired: {
        id: "task-field-label.isFlaggingRequired",
        defaultMessage: "Is Flagging Required",
        description: "Is Flagging Required",
    },
    isPermitRequired: {
        id: "task-field-label.isPermitRequired",
        defaultMessage: "Is Permit Required",
        description: "Is Permit Required",
    },
    permitStatus: {
        id: "task-field-label.permitStatus",
        defaultMessage: "Permit Status",
        description: "Permit Status",
    },
    parentJobClassification: {
        id: "task-field-label.parentJobClassification",
        defaultMessage: "Parent Job Classification",
        description: "Parent Job Classificationy label",
    },
    parentJobId: {
        id: "task-field-label.parentJobId",
        defaultMessage: "Parent Job ID",
        description: "Parent Job ID label",
    },
    networkNumber: {
        id: "task-field-label.networkNumber",
        defaultMessage: "Network Number",
        description: "Network Number label",
    },
    activityCode: {
        id: "task-field-label.activityCode",
        defaultMessage: "Activity Code",
        description: "Activity Code label",
    },
    contractNumber: {
        id: "task-field-label.contractNumber",
        defaultMessage: "Contract Number",
        description: "Contract Number label",
    },
    createdBy: {
        id: "task-field-label.createdBy",
        defaultMessage: "Created by",
        description: "Created By",
    },
    latestFollowUpDate: {
        id: "task-field-label.follow-up-date",
        defaultMessage: "Follow up Date",
        description: "Latest Followup Date",
    },
    referenceNumber: {
        id: "task-field-label.follow-up-reference",
        defaultMessage: "Follow up reference#",
        description: "Latest Followup reference number",
    },
    followUpType: {
        id: "task-field-label.follow-up-type",
        defaultMessage: "Follow up type",
        description: "Latest Followup type",
    },
    additionalAction: {
        id: "admin.work-order-details.additional-action-title",
        defaultMessage: "Additional Action",
        description: "Admin work order additional action title",
    },
    relatedId: {
        id: "task-field-label.relatedId",
        defaultMessage: "Related ID",
        description: "Admin related id column header",
    },
    civic: {
        id: "task-field-label.civic",
        defaultMessage: "Civic",
        description: "civic label",
    },
    streetName: {
        id: "task-field-label.streetName",
        defaultMessage: "Street name",
        description: "Street Name label",
    },
    customerTN: {
        id: "task-field-label.customerTN",
        defaultMessage: "CustomerTN",
        description: "CustomerTN label",
    },
    customerProvince: {
        id: "task-field-label.customerProvince",
        defaultMessage: "Customer Province",
        description: "Customer Province label",
    },
    customerMunicipality: {
        id: "task-field-label.customerMunicipality",
        defaultMessage: "Customer Municipality",
        description: "Customer Municipality label",
    },
    customerCivic: {
        id: "task-field-label.customerCivic",
        defaultMessage: "Customer Civic",
        description: "Customer Civic label",
    },
    customerStreetname: {
        id: "task-field-label.customerStreetname",
        defaultMessage: "Customer Street name",
        description: "Customer Streetname label",
    },
    cumulativeCost: {
        id: "task-field-label.cumulativeCost",
        defaultMessage: "Cumulative Cost",
        description: "Cumulative Cost column label",
    },
    lastModifiedDate: {
        id: "task-field-label.lastModifiedDate",
        defaultMessage: "Last Modified Date",
        description: "Last Modified Date column label",
    },
});

const handleOnMouseEnterOnRow = (event) => {
    event.target.style.overflow = "auto";
    event.target.style.lineHeight = "15px";
};

const handleOnMouseLeaveOnRow = (event) => {
    event.target.style.overflow = "hidden";
    event.target.style.lineHeight = "31px";
};

export const getTaskFieldList = (intl, followUpTypes, setSelectedTask) => [
    {
        headerName: "\xa0",
        field: "\xa0",
        filtering: false,
        sorting: false,
        disableClick: true,
        width: 11,
        renderCell: (params) => (
            <div
                style={{
                    padding: "5.5px",
                    background: "#65ABFE",
                    height: 30,
                    width: "11px !important",
                    borderRadius: "4px 0 0 4px",
                    marginLeft: "-10px",
                }}
            />
        ),
    },
    {
        label: labels.relatedId,
        field: "originalRelatedId",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 185,
    },
    {
        label: labels.workOrderNumber,
        field: "workOrderNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 200,
        renderCell: (params) => {
            const task = params.row;
            return (
                <AdminContextMenu
                    task={task}
                    from="task-list"
                    setSelectedTask={(task) => {
                        if (setSelectedTask) setSelectedTask(task);
                    }}
                />
            );
        },
    },
    {
        label: labels.originalDueDate,
        field: "originalDueDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 185,
        // renderCell: (params) => {
        //   if (params.value) {
        //     let modifiedDate = moment
        //       .utc(new Date(params.value))
        //       .add(-moment().utcOffset(), 'minutes')
        //       .format('YYYY-MM-DDTHH:mm:ss.SSSSZ');
        //     return (
        //       <React.Fragment>
        //         <FormattedDate
        //           value={modifiedDate}
        //           year='numeric'
        //           month='short'
        //           day='numeric'
        //         />
        //       </React.Fragment>
        //     );
        //   } else {
        //     return intl.formatMessage(labels.noOriginalDueDate);
        //   }
        // },
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, intl.formatMessage(labels.noOriginalDueDate)),
        sortComparator: FieldFormatters.oddComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
    {
        label: labels.appointmentDueDate,
        field: "appointmentDueDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 250,
        renderCell: (params) => <DueDateRenderer params={params} />,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, ""),
        sortComparator: FieldFormatters.oddComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
    {
        label: labels.phoneNumber,
        field: "phoneNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        valueFormatter: (params) => FieldFormatters.phoneNumberFormatter(params, ""),
    },
    {
        label: labels.circuitNumber,
        field: "circuitNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.activties,
        field: "activties",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 165,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.status,
        field: "status",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 165,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.additionalAction,
        field: "additionalAction_Display",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.reasonCode,
        field: "reasonCode",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 235,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.priority,
        field: "priority",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 165,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.resourceAssignedTo,
        field: "resourceAssigned",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 230,
        renderCell: AssignToRenderer,
        valueFormatter: (params) => AssignedToFormatter(intl, params),
        sortComparator: FieldFormatters.assignToComparator(intl),
        //   renderCell: (params) => (
        //     <div
        //       onMouseEnter={handleOnMouseEnterOnRow}
        //       onMouseLeave={handleOnMouseLeaveOnRow}
        //       onTouchStart={handleOnMouseEnterOnRow}
        //       onTouchEnd={handleOnMouseLeaveOnRow}
        //     >
        //       {AssignToRenderer}
        //     </div>
        // ),
    },
    {
        label: labels.scheduledDate,
        field: "scheduledDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: (params) => FieldFormatters.dateTimeStampValueFormatter(params, intl.formatMessage(labels.notScheduled)),
        sortComparator: FieldFormatters.dateComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeStampExcelFormatter(params),
    },
    {
        label: labels.workType,
        field: "workType",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.networkType,
        field: "networkType",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.plantType,
        field: "plantType",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.Was_a_Temp_Placed,
        field: "Was_Temp_Placed",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 260,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.completionDate,
        field: "completionDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatters(params, ""),
        sortComparator: FieldFormatters.dateComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatters(params),
    },
    {
        label: labels.completionCode,
        field: "completionCode",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 200,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.contractor,
        field: "contractorName",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {params.value}
            </div>
        ),
    },
    {
        label: labels.clickRegion,
        field: "region",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
    },
    {
        label: labels.clickDistrict,
        field: "district",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
    },
    {
        label: labels.clliCode,
        field: "zone",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
    },
    {
        label: labels.province,
        field: "province",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 165,
    },
    {
        label: labels.municipality,
        field: "municipality",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 165,
    },
    {
        label: labels.civic,
        field: "civicNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.streetName,
        field: "streetName",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {params.value}
            </div>
        ),
    },
    {
        label: labels.customerTN,
        field: "customerPhoneNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: (params) => FieldFormatters.phoneNumberFormatter(params, ""),
    },
    {
        label: labels.customerProvince,
        field: "customerProvince",
        fieldType: "text",
        filtering: true,
        width: 200,
        sorting: true,
    },
    {
        label: labels.customerMunicipality,
        field: "customerMuncipality",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 230,
    },
    {
        label: labels.customerCivic,
        field: "civicAddress",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 230,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.customerStreetname,
        field: "customerStreetName",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 230,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.locateNumber,
        field: "locateNumbers",
        fieldType: "numeric",
        filtering: true,
        sorting: true,
        width: 250,
        excelFormatter: (params) => FieldFormatters.localeExcelFormatter(params),
    },
    {
        label: labels.requestedDate,
        field: "locateRequestedDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 280,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, ""),
        sortComparator: FieldFormatters.oddComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
    {
        label: labels.expirationDate,
        field: "locateExpirationDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 280,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, ""),
        sortComparator: FieldFormatters.oddComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
    {
        label: labels.isFlaggingRequired,
        field: "flaggingRequired",
        filtering: true,
        sorting: true,
        width: 280,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.isPermitRequired,
        field: "permitRequired",
        filtering: true,
        sorting: true,
        width: 250,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.permitStatus,
        field: "permitStatus",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 200,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.createdBy,
        field: "technicianId",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 165,
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {params.value}
            </div>
        ),
    },
    {
        label: labels.creationDate,
        field: "creationDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 220,
        valueFormatter: (params) => FieldFormatters.dateTimeStampValueFormatters(params, ""),
        sortComparator: FieldFormatters.dateComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeStampExcelFormatters(params),
    },
    {
        label: labels.parentJobClassification,
        field: "parentJobClassification",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 290,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
    },
    {
        label: labels.SourceTicketID,
        field: "sourceOrderId",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 260,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {params.value}
            </div>
        ),
    },
    {
        label: labels.networkNumber,
        field: "networkNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 200,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.activityCode,
        field: "networkActivity",
        fieldType: "alphaNumeric",
        filtering: true,
        width: 210,
        sorting: true,
        sortComparator: FieldFormatters.sortAlphaNumComparator(intl),
    },
    {
        label: labels.contractNumber,
        field: "contractNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 200,
    },
    {
        label: labels.followUpType,
        field: "followUpType",
        fieldType: "text",
        filtering: true,
        sorting: true,
        width: 235,
        valueFormatter: FieldFormatters.fkFormatter(intl),
        sortComparator: FieldFormatters.fkComparator(intl),
        renderCell: (params) => (
            <div
                onMouseEnter={handleOnMouseEnterOnRow}
                onMouseLeave={handleOnMouseLeaveOnRow}
                onTouchStart={handleOnMouseEnterOnRow}
                onTouchEnd={handleOnMouseLeaveOnRow}>
                {FieldFormatters.fkFormatter(intl)(params)}
            </div>
        ),
    },
    {
        label: labels.referenceNumber,
        field: "referenceTicketNumber",
        fieldType: "alphaNumeric",
        filtering: true,
        sorting: true,
        width: 300,
    },
    {
        label: labels.latestFollowUpDate,
        field: "followUpDueDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 200,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, ""),
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
    {
        label: labels.cumulativeCost,
        field: "cumulativeCost",
        fieldType: "numeric",
        filtering: true,
        sorting: true,
        width: 200,
        valueFormatter: (params) => FieldFormatters.cumulativeCost(params),
        excelFormatter: (params) => FieldFormatters.cumulativeCost(params),
    },
    // {
    //   label: labels.completionDate,
    //   field: 'completionDate',
    //   fieldType: 'date',
    //   filtering: true,
    //   sorting: true,
    //   valueFormatter: (params) => FieldFormatters.dateTimeSecValueFormatters(params, ''),
    //   sortComparator: FieldFormatters.dateComparator,
    //   excelFormatter: (params) => FieldFormatters.dateTimeSecExcelFormatters(params),
    // },
    {
        label: labels.lastModifiedDate,
        field: "lastModifiedDate",
        fieldType: "date",
        filtering: true,
        sorting: true,
        width: 270,
        valueFormatter: (params) => FieldFormatters.dateTimeValueFormatter(params, ""),
        sortComparator: FieldFormatters.oddComparator,
        excelFormatter: (params) => FieldFormatters.dateTimeExcelFormatter(params),
    },
];
